// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { switchLanguage } from "../features/language/languageSlice";

// const LanguageSwitch = ({ language, languages, onChange }) => {
//   return (
//     <select
//       value={language}
//       onChange={(e) => onChange(e.target.value)}
//       className="cursor-pointer px-1 font-bold flex bg-transparent text-[#9CCAFE] focus:outline-none appearance-none"
//     >
//       {[...languages]
//         .sort((a, b) => a.name.localeCompare(b.name))
//         .map(({ code, name }) => (
//           <option key={code} value={code}>
//             {name}
//           </option>
//         ))}
//     </select>
//   );
// };

// export default LanguageSwitch;

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { switchLanguage } from "../features/language/languageSlice";

// import tr from "../../src/icons-svg/icon_language-pink_tr.svg";
// import en from "../../src/icons-svg/icon_language-pink_en.svg";
// import fr from "../../src/icons-svg/icon_language-pink_fr.svg";
// import de from "../../src/icons-svg/icon_language-pink_de.svg";

// const FLAGS = [
//   { code: "fr-FR", label: "FR", src: fr },
//   { code: "en-EN", label: "EN", src: en },
//   { code: "de-DE", label: "DE", src: de },
//   { code: "tr-TR", label: "TR", src: tr },
// ];

// const normalizeLang = (v = "") =>
//   String(v).trim().toLowerCase().replace("_", "-");

// const LanguageSwitch = () => {
//   const dispatch = useDispatch();
//   const wrapRef = useRef(null);
//   const [open, setOpen] = useState(false);

//   const { language, languages } = useSelector((state) => state.language || {});
//   const activeLang = language || "tr-TR";

//   const menuItems = useMemo(() => {
//     if (Array.isArray(languages) && languages.length > 0) {
//       return [...languages]
//         .map((l) => {
//           const f =
//             FLAGS.find((x) => normalizeLang(x.code) === normalizeLang(l.code)) ||
//             FLAGS.find((x) =>
//               normalizeLang(x.code).startsWith(normalizeLang(l.code))
//             ) ||
//             null;

//           return {
//             code: l.code,
//             label: (l.name || l.code || "").toString(),
//             short:
//               (l.code || "").split("-")[0]?.toUpperCase() ||
//               (l.name || "").slice(0, 2).toUpperCase(),
//             src: f?.src,
//           };
//         })
//         .sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//     }

//     return FLAGS.map((f) => ({
//       code: f.code,
//       label: f.label,
//       short: f.label,
//       src: f.src,
//     }));
//   }, [languages]);

//   const current = useMemo(() => {
//     const cur = normalizeLang(activeLang);

//     const exact = menuItems.find((x) => normalizeLang(x.code) === cur);
//     if (exact) return exact;

//     const base = cur.split("-")[0];
//     const byBase = menuItems.find((x) =>
//       normalizeLang(x.code).startsWith(base)
//     );
//     return byBase || menuItems[menuItems.length - 1];
//   }, [activeLang, menuItems]);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!wrapRef.current) return;
//       if (!wrapRef.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const onSelect = (code) => {
//     dispatch(switchLanguage(code));
//     setOpen(false);
//   };

//   return (
//     <nav className="flex items-center w-full">
//       <div />
//       <div ref={wrapRef} className="relative ml-auto mr-2">
//         <button
//           type="button"
//           onClick={() => setOpen((v) => !v)}
//           className="
//             inline-flex items-center justify-center
//             p-1 rounded-md
//             bg-transparent
//             transition
//             focus:outline-none focus-visible:ring-2
//           "
//           aria-haspopup="menu"
//           aria-expanded={open}
//           title={current?.label}
//         >
//           {current?.src ? (
//             <img src={current.src} className="w-5 h-5" alt={current.label} />
//           ) : (
//             <span className="bg-gray-300 text-sm font-semibold px-1">
//               {current?.short || "TR"}
//             </span>
//           )}
//         </button>

//         {open && (
//           <div
//             className="
//               absolute right-0 mt-2
//               w-fit
//               rounded-lg overflow-hidden bg-gray-300
//                dark:bg-gray-300
//               border border-gray-200 dark:border-gray-700
//               shadow-lg z-50
//             "
//             role="menu"
//           >
//             {menuItems.map((item) => (
//               <button
//                 key={item.code}
//                 type="button"
//                 onClick={() => onSelect(item.code)}
//                 className="
//                   w-full
//                   px-3 py-2
//                   text-left whitespace-nowrap
//                   hover:bg-gray-100 dark:hover:bg-white/10
//                   text-gray-800 dark:text-white
//                 "
//                 role="menuitem"
//               >
//                 <span className="text-sm font-medium">
//                   {item.short || item.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default LanguageSwitch;

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { switchLanguage } from "../features/language/languageSlice";

// import tr from "../../src/icons-svg/icon_language-pink_tr.svg";
// import en from "../../src/icons-svg/icon_language-pink_en.svg";
// import fr from "../../src/icons-svg/icon_language-pink_fr.svg";
// import de from "../../src/icons-svg/icon_language-pink_de.svg";

// const FLAGS = [
//   { code: "fr-FR", label: "FR", src: fr },
//   { code: "en-EN", label: "EN", src: en },
//   { code: "de-DE", label: "DE", src: de },
//   { code: "tr-TR", label: "TR", src: tr },
// ];

// const normalizeLang = (v = "") =>
//   String(v).trim().toLowerCase().replace("_", "-");

// // ✅ tarayıcı dili -> mevcut languages içinde en iyi eşleşme
// const pickBestLang = (languages = [], browser = "") => {
//   const b = normalizeLang(browser);
//   const base = b.split("-")[0];

//   // 1) tam eşleşme: en-us == en-us
//   const exact = languages.find((l) => normalizeLang(l.code) === b);
//   if (exact) return exact.code;

//   // 2) base eşleşme: en == en-us / en-en gibi
//   const byBase = languages.find((l) => normalizeLang(l.code).startsWith(base));
//   if (byBase) return byBase.code;

//   // 3) yoksa TR varsa TR, yoksa ilk
//   const trOpt = languages.find((l) => normalizeLang(l.code).startsWith("tr"));
//   return (trOpt?.code || languages[0]?.code || "tr-TR");
// };

// const LanguageSwitch = () => {
//   const dispatch = useDispatch();
//   const wrapRef = useRef(null);
//   const [open, setOpen] = useState(false);

//   const { language, languages } = useSelector((state) => state.language || {});
//   const activeLang = language || "tr-TR";

//   // ✅ 1) proje açılır açılmaz tarayıcı dili set et
//   useEffect(() => {
//     if (!Array.isArray(languages) || languages.length === 0) return;

//     const browserLang =
//       (navigator.languages && navigator.languages[0]) ||
//       navigator.language ||
//       "tr-TR";

//     const best = pickBestLang(languages, browserLang);

//     // store dili tarayıcı dilinden farklıysa güncelle
//     if (normalizeLang(best) !== normalizeLang(activeLang)) {
//       dispatch(switchLanguage(best));
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [dispatch, languages]); // ⚠️ activeLang'ı bilerek koymadım: döngüye girme riskini azaltır

//   const menuItems = useMemo(() => {
//     if (Array.isArray(languages) && languages.length > 0) {
//       return [...languages]
//         .map((l) => {
//           const f =
//             FLAGS.find((x) => normalizeLang(x.code) === normalizeLang(l.code)) ||
//             FLAGS.find((x) => normalizeLang(x.code).startsWith(normalizeLang(l.code))) ||
//             null;

//           return {
//             code: l.code,
//             label: (l.name || l.code || "").toString(),
//             short:
//               (l.code || "").split("-")[0]?.toUpperCase() ||
//               (l.name || "").slice(0, 2).toUpperCase(),
//             src: f?.src,
//           };
//         })
//         .sort((a, b) => (a.label || "").localeCompare(b.label || ""));
//     }

//     return FLAGS.map((f) => ({
//       code: f.code,
//       label: f.label,
//       short: f.label,
//       src: f.src,
//     }));
//   }, [languages]);

//   const current = useMemo(() => {
//     const cur = normalizeLang(activeLang);

//     const exact = menuItems.find((x) => normalizeLang(x.code) === cur);
//     if (exact) return exact;

//     const base = cur.split("-")[0];
//     const byBase = menuItems.find((x) => normalizeLang(x.code).startsWith(base));
//     return byBase || menuItems[menuItems.length - 1];
//   }, [activeLang, menuItems]);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!wrapRef.current) return;
//       if (!wrapRef.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const onSelect = (code) => {
//     dispatch(switchLanguage(code));
//     setOpen(false);
//   };

//   return (
//     <nav className="flex items-center w-full">
//       <div />
//       <div ref={wrapRef} className="relative ml-auto mr-2">
//         <button
//           type="button"
//           onClick={() => setOpen((v) => !v)}
//           className="
//             inline-flex items-center justify-center
//             p-1 rounded-md
//             bg-transparent
//             transition
//             focus:outline-none focus-visible:ring-2
//           "
//           aria-haspopup="menu"
//           aria-expanded={open}
//           title={current?.label}
//         >
//           {current?.src ? (
//             <img src={current.src} className="w-5 h-5" alt={current.label} />
//           ) : (
//             <span className="bg-gray-300 text-sm font-semibold px-1">
//               {current?.short || "TR"}
//             </span>
//           )}
//         </button>

//         {open && (
//           <div
//             className="
//               absolute right-0 mt-2
//               w-fit
//               rounded-lg overflow-hidden bg-gray-300
//               dark:bg-gray-300
//               border border-gray-200 dark:border-gray-700
//               shadow-lg z-50
//             "
//             role="menu"
//           >
//             {menuItems.map((item) => (    
//               <button
//                 key={item.code}
//                 type="button"
//                 onClick={() => onSelect(item.code)}
//                 className="
//                   w-full
//                   px-3 py-2
//                   text-left whitespace-nowrap
//                   hover:bg-gray-100 dark:hover:bg-white/10
//                   text-gray-800 dark:text-white
//                 "
//                 role="menuitem"
//               >
//                 <span className="text-sm font-medium">
//                   {item.short || item.label}
//                 </span>
//               </button>
//             ))}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default LanguageSwitch;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { switchLanguage } from "../features/language/languageSlice";
import { useTranslation } from "react-i18next";

import tr from "../../src/icons-svg/icon_language-pink_tr.svg";
import en from "../../src/icons-svg/icon_language-pink_en.svg";
import fr from "../../src/icons-svg/icon_language-pink_fr.svg";
import de from "../../src/icons-svg/icon_language-pink_de.svg";

const FLAGS = [
  { code: "fr-FR", label: "FR", src: fr },
  { code: "en-EN", label: "EN", src: en },
  { code: "de-DE", label: "DE", src: de },
  { code: "tr-TR", label: "TR", src: tr },
];

const normalizeLang = (v = "") =>
  String(v).trim().toLowerCase().replace("_", "-");

// ✅ tarayıcı dili -> mevcut languages içinde en iyi eşleşme
const pickBestLang = (languages = [], browser = "") => {
  const b = normalizeLang(browser);
  const base = b.split("-")[0];

  // 1) tam eşleşme
  const exact = languages.find((l) => normalizeLang(l.code) === b);
  if (exact) return exact.code;

  // 2) base eşleşme
  const byBase = languages.find((l) => normalizeLang(l.code).startsWith(base));
  if (byBase) return byBase.code;

  // 3) yoksa TR varsa TR, yoksa ilk
  const trOpt = languages.find((l) => normalizeLang(l.code).startsWith("tr"));
  return trOpt?.code || languages[0]?.code || "tr-TR";
};

// ✅ parent’a haber vermek için prop ekledik
const LanguageSwitch = ({ onChangeLang }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);

  const { language, languages } = useSelector((state) => state.language || {});
  const activeLang = language || "tr-TR";

  // ✅ 1) proje açılır açılmaz tarayıcı dili set et
  useEffect(() => {
    if (!Array.isArray(languages) || languages.length === 0) return;

    const browserLang =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      "tr-TR";

    const best = pickBestLang(languages, browserLang);

    if (normalizeLang(best) !== normalizeLang(activeLang)) {
      dispatch(switchLanguage(best));
      i18n.changeLanguage(best);       // ✅ UI çevirisi
      onChangeLang?.(best);            // ✅ parent fetch tetiklesin
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, languages]); // activeLang bilerek yok

  const menuItems = useMemo(() => {
    if (Array.isArray(languages) && languages.length > 0) {
      return [...languages]
        .map((l) => {
          const f =
            FLAGS.find((x) => normalizeLang(x.code) === normalizeLang(l.code)) ||
            FLAGS.find((x) =>
              normalizeLang(x.code).startsWith(normalizeLang(l.code))
            ) ||
            null;

          return {
            code: l.code,
            label: (l.name || l.code || "").toString(),
            short:
              (l.code || "").split("-")[0]?.toUpperCase() ||
              (l.name || "").slice(0, 2).toUpperCase(),
            src: f?.src,
          };
        })
        .sort((a, b) => (a.label || "").localeCompare(b.label || ""));
    }

    return FLAGS.map((f) => ({
      code: f.code,
      label: f.label,
      short: f.label,
      src: f.src,
    }));
  }, [languages]);

  const current = useMemo(() => {
    const cur = normalizeLang(activeLang);

    const exact = menuItems.find((x) => normalizeLang(x.code) === cur);
    if (exact) return exact;

    const base = cur.split("-")[0];
    const byBase = menuItems.find((x) =>
      normalizeLang(x.code).startsWith(base)
    );
    return byBase || menuItems[menuItems.length - 1];
  }, [activeLang, menuItems]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const onSelect = (code) => {
    dispatch(switchLanguage(code));
    i18n.changeLanguage(code);    // ✅ UI çevirisi
    onChangeLang?.(code);         // ✅ parent fetch tetiklesin
    setOpen(false);
  };

  return (
    <nav className="flex items-center w-full">
      <div />
      <div ref={wrapRef} className="relative ml-auto mr-2">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="
            inline-flex items-center justify-center
            p-1 rounded-md
            bg-transparent
            transition
            focus:outline-none focus-visible:ring-2
          "
          aria-haspopup="menu"
          aria-expanded={open}
          title={current?.label}
        >
          {current?.src ? (
            <img src={current.src} className="w-5 h-5" alt={current.label} />
          ) : (
            <span className="bg-gray-300 text-sm font-semibold px-1">
              {current?.short || "TR"}
            </span>
          )}
        </button>

        {open && (
          <div
            className="
              absolute right-0 mt-2
              w-fit
              rounded-lg overflow-hidden bg-gray-300
              dark:bg-gray-300
              border border-gray-200 dark:border-gray-700
              shadow-lg z-50
            "
            role="menu"
          >
            {menuItems.map((item) => (
              <button
                key={item.code}
                type="button"
                onClick={() => onSelect(item.code)}
                className="
                  w-full
                  px-3 py-2
                  text-left whitespace-nowrap
                  hover:bg-gray-100 dark:hover:bg-white/10
                  text-gray-800 dark:text-white
                "
                role="menuitem"
              >
                <span className="text-sm font-medium">
                  {item.short || item.label}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default LanguageSwitch;
